import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { firestore } from './firebase/firebase';

/**
 * Service « Tableau de bord » — lectures légères pour le pilotage admin.
 * Conventions : volumes actuels faibles → lectures directes côté client
 * (pattern déjà utilisé dans l'admin) ; aucune écriture ici.
 */

const USERS_COLLECTION = 'users';
const SITES_COLLECTION = 'sites';

const toDateValue = (value) => {
  if (!value) return null;
  try {
    if (typeof value.toDate === 'function') return value.toDate();
    if (value.seconds) return new Date(value.seconds * 1000);
    if (value instanceof Date) return value;
    if (typeof value === 'string') return new Date(value);
    return null;
  } catch (error) {
    return null;
  }
};

/**
 * Derniers clients inscrits.
 * @param {number} max - Nombre maximum
 */
export const getLatestClients = async (max = 5) => {
  try {
    const q = query(
      collection(firestore, USERS_COLLECTION),
      orderBy('createdAt', 'desc'),
      limit(max)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map((docSnap) => {
      const data = docSnap.data();
      return {
        id: docSnap.id,
        uid: data.uid || docSnap.id,
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        isCompany: data.isCompany || false,
        createdAt: toDateValue(data.createdAt)
      };
    });
  } catch (error) {
    console.warn('dashboardService: erreur derniers clients', error?.message);
    return [];
  }
};

/**
 * Données agrégées des sites (total, en ligne, derniers publiés).
 * @param {number} recent - Nombre de sites récemment publiés à renvoyer
 */
export const getSiteDashboardData = async (recent = 5) => {
  try {
    const snapshot = await getDocs(collection(firestore, SITES_COLLECTION));
    const sites = snapshot.docs.map((docSnap) => {
      const data = docSnap.data();
      const publishInfo = data.publishInfo || {};
      return {
        id: docSnap.id,
        domainName: publishInfo.domainName || '',
        publishedAt: toDateValue(publishInfo.publishedAt),
        updatedAt: toDateValue(data.updatedAt || publishInfo.updatedAt)
      };
    });

    const published = sites
      .filter((site) => site.domainName)
      .sort((a, b) => (b.publishedAt?.getTime?.() || 0) - (a.publishedAt?.getTime?.() || 0));

    return {
      total: sites.length,
      published: published.length,
      recentPublished: published.slice(0, recent)
    };
  } catch (error) {
    console.warn('dashboardService: erreur données sites', error?.message);
    return { total: 0, published: 0, recentPublished: [] };
  }
};
